import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';

@Injectable({ providedIn: 'root' })
export class TicketService extends EntityCollectionServiceBase<any> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('TicketCount', serviceElementsFactory);
    }
}
